import React from 'react';
import { useNavigate } from 'react-router-dom';
import { PhoneFrame } from '../PhoneMockups';
import { AppleIcon, GooglePlayIcon } from '../StoreIcons';
import { APP_STORE_URL, PLAY_STORE_URL, openStore } from '../appLinks';

export function ForOrganizations() {
  const navigate = useNavigate();

  return (
    <>
      <div className="page-hero">
        <div className="ph-text">
          <p className="s-eyebrow">For Organizations</p>
          <h1 className="hero-h1" style={{ fontSize: 'clamp(44px,5vw,72px)', marginBottom: 24 }}>Find and hire music talent<br /><em>you can trust.</em></h1>
          <p className="s-body" style={{ marginBottom: 36 }}>Discover vetted professionals, post gigs, manage your roster, and pay safely — all in one place built for labels, studios, production houses, and music companies.</p>
          <div className="cta-actions">
            <button className="btn btn-primary btn-lg" onClick={() => navigate('/redirect')}>Get the app</button>
          </div>
        </div>
        <div className="ph-phone">
          <PhoneFrame style={{ width: 260, height: 540 }} screen="hire" frameWidth={260} />
        </div>
      </div>

      <div className="s-bg1" id="page-features">
        <div className="s-wrap">
          <div className="fcards">
            <div className="fcard">
              <svg className="fcard-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"><circle cx="11" cy="11" r="7" /><line x1="22" y1="22" x2="16" y2="16" /></svg>
              <div className="fcard-title">Discover the right talent, fast</div>
              <div className="fcard-body">Search thousands of professional profiles. Filter by genre, skill, location, and credits to find exactly who you need — no more digging through DMs.</div>
            </div>
            <div className="fcard">
              <svg className="fcard-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"><rect x="4" y="8" width="20" height="16" rx="2" /><path d="M10 8V6a4 4 0 018 0v2" /><line x1="14" y1="14" x2="14" y2="18" /></svg>
              <div className="fcard-title">Post gigs and reach working professionals</div>
              <div className="fcard-body">List sessions, shows, projects, and collaboration opportunities — and receive applications from professionals ready to work.</div>
            </div>
            <div className="fcard">
              <svg className="fcard-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"><rect x="3" y="6" width="22" height="16" rx="2" /><line x1="3" y1="11" x2="25" y2="11" /><line x1="8" y1="16" x2="12" y2="16" /><line x1="8" y1="19" x2="16" y2="19" /></svg>
              <div className="fcard-title">Manage your roster in one place</div>
              <div className="fcard-body">Track your artists, agreements, and communication without juggling spreadsheets and DMs. Everything your team needs, centralised.</div>
            </div>
            <div className="fcard">
              <svg className="fcard-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" strokeWidth={1.7} strokeLinecap="round" strokeLinejoin="round"><path d="M14 4v4M14 20v4M4 14h4M20 14h4" /><circle cx="14" cy="14" r="6" /><path d="M11 14h6M14 11v6" /></svg>
              <div className="fcard-title">Transact with confidence</div>
              <div className="fcard-body">Escrow-protected payments and on-platform agreements mean every engagement is clear, documented, and safe for everyone involved.</div>
            </div>
          </div>
        </div>
      </div>

      <section className="s-bg4 cta-strip">
        <h2 className="s-h2">Find your next collaborator.</h2>
        <p className="s-body">Post a gig and reach a community of working music professionals today.</p>
        <div className="app-badges">
          <div className="app-badge" onClick={() => openStore(APP_STORE_URL)}>
            <AppleIcon />
            <div className="app-badge-text"><span className="app-badge-sub">Download on the</span><span className="app-badge-name">App Store</span></div>
          </div>
          <div className="app-badge" onClick={() => openStore(PLAY_STORE_URL)}>
            <GooglePlayIcon className="app-badge-play-icon" />
            <div className="app-badge-text"><span className="app-badge-sub">Get it on</span><span className="app-badge-name">Google Play</span></div>
          </div>
        </div>
      </section>
    </>
  );
}
